import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { useDate } from "../../../hooks/useDate";
import LoadingChart from "../../Home/components/loadingChart";

export default function ConcentradoAlimentado() {
  // Objecto default del state
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Peticion inicial de esta grafica
  const initialFetch = new TostadorFetching()
    .setIdSeccion(8)
    .setSecuencia(2)
    .setFrecuencia(720)
    .setDias(7);

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();
  const [isLoading, setIsLoading] = useState(true);

  const [cutConAlim, setCutConAlim] = useState(defaultObject);
  const [leyCuPlanSemanalCon, setLeyCuPlanSemanalCon] = useState(defaultObject);
  const [asConcentradoAlim, setAsConcentradoAlim] = useState(defaultObject);
  const [leyAsPlanSemanalCon, setLeyAsPlanSemanalCon] = useState(defaultObject);
  const [sConcentradoAlimentado, setSConcentradoAlimentado] =
    useState(defaultObject);
  const [leySPlanSemanalCon, setLeySPlanSemanalCon] = useState(defaultObject);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getValoresPeriodo(initialFetch);
      console.log(data)
      populateCuConAlim(data);
      populateLeyCuPlanSemanalCon(data);
      populateAsConcentradoAlim(data);
      populateLeyAsPlanSemanalCon(data);
      populateSConcentradoAlimentado(data);
      populateLeySPlanSemanal(data);
      setDateHook(data, "Conc_Alim_CuT");

      setTimeout(() => {
        fetchData();
      }, 300000);

      setIsLoading(false);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateLeySPlanSemanal(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "LEY_S_CONC.PS"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLeySPlanSemanalCon({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSConcentradoAlimentado(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter((element) => element.Detalle === "Conc_Alim_S");

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setSConcentradoAlimentado({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLeyAsPlanSemanalCon(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "LEY_AS_CONC.PS"
    );


 
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLeyAsPlanSemanalCon({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAsConcentradoAlim(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Conc_Alim_As"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setAsConcentradoAlim({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCuConAlim(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Conc_Alim_CuT"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCutConAlim({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLeyCuPlanSemanalCon(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "LEY_CU_CONC.PS"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLeyCuPlanSemanalCon({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              title="Concentrado Alimentado - Reporte"
              subtitle={"Periodo " + fullDate()}
              zoom="x"
            >
              <Chart.Column
                name="%CuT Concentrado Alimentado - Reporte"
                data={cutConAlim.value}
              />

              <Chart.Line
                name="Ley Cu Plan Semanal Concentrado"
                data={leyCuPlanSemanalCon.value}
              />

              <Chart.Column
                name="%As Concentrado Alimentado - Reporte"
                yAxis={1}
                data={asConcentradoAlim.value}
              />

              <Chart.Line
                name="Ley As Plan Semanal Concentrado"
                yAxis={1}
                data={leyAsPlanSemanalCon.value}
              />

              <Chart.Column
                name="%S Concentrado Alimentado - Reporte"
                data={sConcentradoAlimentado.value}
              />

              <Chart.Line
                name="Ley S Plan Semanal Concentrado"
                data={leySPlanSemanalCon.value}
              />

              <Chart.XAxis
                allowDecimals={false}
                categories={asConcentradoAlim.fecha}
              />

              <Chart.YAxis
              
                labelSuffix=" %"
                title="Conteido Cu - S, %"
                lineWidth={2}
                lineColor="white"
                min={0}
              />

              <Chart.YAxis
                labelSuffix=" %"
                title="Contenido As, %"
                lineWidth={2}
                opposite={true}
                lineColor="white"
                min={0}
              />
              <Chart.YAxis labelSuffix=" %" />
              <Chart.Tooltip valueSuffix=" %" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
